module.exports = __webpack_public_path__ + "static/NewF1Banner_BladeAndSoul-d52161e62cd6bfb8055a8795e3ab41b1.jpg";